module.exports = __webpack_public_path__ + "img/ebanner.2559200d.png";